import React from 'react';
import styled from 'styled-components';

import { LoadingSpinner } from '@hoffmann/pattern-library-2';

export const LoadingSpinnerPage: React.FC = () => (
  <Page data-cy="loading-spinner">
    <LoadingSpinner size={300} />
  </Page>
);

const Page = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
